/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * The CMS API!
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { EntitlementType } from './entitlement-type';
import { LocalizedFieldBody } from './localized-field-body';
import { PageListItemBody } from './page-list-item-body';
import { TargetPlatform } from './target-platform';
import { UiModuleExperimentGroup } from './ui-module-experiment-group';
import { UiModulePageListTreatment } from './ui-module-page-list-treatment';

/**
 * 
 * @export
 * @interface PageListUiModuleBody
 */
export interface PageListUiModuleBody {
    /**
     * 
     * @type {string}
     * @memberof PageListUiModuleBody
     */
    moduleId?: string;
    /**
     * 
     * @type {string}
     * @memberof PageListUiModuleBody
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof PageListUiModuleBody
     */
    hash?: string;
    /**
     * 
     * @type {string}
     * @memberof PageListUiModuleBody
     */
    moduleType: PageListUiModuleBodyModuleTypeEnum;
    /**
     * 
     * @type {Array<TargetPlatform>}
     * @memberof PageListUiModuleBody
     */
    targetPlatform?: Array<TargetPlatform>;
    /**
     * 
     * @type {LocalizedFieldBody}
     * @memberof PageListUiModuleBody
     */
    caption?: LocalizedFieldBody;
    /**
     * 
     * @type {Array<EntitlementType>}
     * @memberof PageListUiModuleBody
     */
    entitlements?: Array<EntitlementType>;
    /**
     * 
     * @type {Array<UiModuleExperimentGroup>}
     * @memberof PageListUiModuleBody
     */
    experiments?: Array<UiModuleExperimentGroup> | null;
    /**
     * 
     * @type {LocalizedFieldBody}
     * @memberof PageListUiModuleBody
     */
    title: LocalizedFieldBody;
    /**
     * 
     * @type {Array<PageListItemBody>}
     * @memberof PageListUiModuleBody
     */
    pages: Array<PageListItemBody>;
    /**
     * 
     * @type {UiModulePageListTreatment}
     * @memberof PageListUiModuleBody
     */
    pageListTreatment: UiModulePageListTreatment;
}

/**
    * @export
    * @enum {string}
    */
export enum PageListUiModuleBodyModuleTypeEnum {
    PAGE_LIST = 'PAGE_LIST'
}



